import React from 'react';
import { ViewMode } from '../../DeviceDetails/constants';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from 'components/shadcn/ui/select';

const labels = {
    [ViewMode.DAY]: 'Day',
    [ViewMode.MONTH]: 'Month',
    [ViewMode.WEEK]: 'Week',
    [ViewMode.YEAR]: 'Year',
};

const menuItems = [
    {
        label: labels[ViewMode.DAY],
        value: ViewMode.DAY,
    },
    {
        label: labels[ViewMode.WEEK],
        value: ViewMode.WEEK,
    },
    {
        label: labels[ViewMode.MONTH],
        value: ViewMode.MONTH,
    },
    {
        label: labels[ViewMode.YEAR],
        value: ViewMode.YEAR,
    },
];

const ViewModeDropdown = ({ viewMode, setViewMode }) => {
    return (
        <Select
            value={viewMode}
            onValueChange={(value) => setViewMode(value)}
            className="max-w-md"
        >
            <SelectTrigger className="w-auto max-w-lg gap-1">
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                {menuItems.map((item, index) => {
                    return (
                        <SelectItem
                            key={index}
                            value={item.value}
                        >
                            {item.label}
                        </SelectItem>
                    );
                })}
            </SelectContent>
        </Select>
    );
};

export default ViewModeDropdown;
